import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../../services/navbar.service';
import { SessionService } from '../../services/session.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent implements OnInit {

  navbar: NavbarService;

  constructor(private navbarService: NavbarService, private sessionService: SessionService,
    private toastr: ToastrService, private router: Router) {

  }

  ngOnInit() {
    this.navbar = this.navbarService;
    let data = JSON.parse(localStorage.getItem('session'));
    this.navbarService.mostrar = (!data.usuario);
    if (data.usuario){
      this.navbarService.usuario = data.usuario;
    } else {
      this.navbarService.usuario = "";
    }
  }

  logout() {
    this.sessionService.logout().subscribe(
      (resp: any) => {
        this.toastr.success('Sessión cerrada', 'Éxito');
        this.navbarService.mostrar = true;
        this.navbarService.usuario = "";
        localStorage.removeItem("session");
        this.router.navigate(['']);
      }, err => {
        this.toastr.error(err.error.messages[0], 'Error');
      }
    );
  }
}
